import { useState } from "react";
import { addData } from "./../../Redux/GetDataReducer/action";
import {Alert, Box, Button, Input, AlertIcon, AlertTitle, useToast} from '@chakra-ui/react'
import { useDispatch } from "react-redux";


  

function AddProduct(){
  const toast = useToast()
    const [nameOfHotel,setNameOfHotel] = useState('')
    const [priceOfHotel,setPriceOfHotel] = useState('')
    const [currencyOfHotel,setCurrencyOfHotel] = useState('')
    const [phoneNumberOfHotel,setPhoneNumberOfHotel] = useState('')
    const [cityOfHotel,setCityOfHotel] = useState('')
    const [starOfHotel,setStarOfHotel] = useState('')
    const dispatch = useDispatch()

    let dataToAdd=    {
        "name": nameOfHotel,
        "currency": currencyOfHotel,
        "price": priceOfHotel,
        "starRating": starOfHotel,
        "description": {
          "short": "How would you like to spend a week or longer with a beautiful, white sandy beach right at your doorstep? You can, when you stay at Royal Palm Beach Resort on Saint Martin/Saint Maarten in the Caribbean. Just imagine strolling along the gorgeous beach, swimming in the sparkling blue waters, and just relaxing by the pool at the resort.  If you are looking for the ultimate in relaxing vacations, you will find it at Royal Palm Beach Resort."
        },
        "phoneNumbers": [
          phoneNumberOfHotel
        ],
        "emails": [
          "gdapi-staging-hotel+3faf8507-307f-4846-936c-a1465b3cfc42@getimpala.com"
        ],
        "websiteUrl": null,
        "images": [
          {
            "altText": null,
            "height": 2534,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec55gi008x0uo52tnnaw5c.jpg",
            "isHeroImage": true
          },
          {
            "altText": null,
            "height": 2534,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec4k5j008t0uo5828shuij.jpg",
            "isHeroImage": false
          },
          {
            "altText": null,
            "height": 2527,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec4prc008u0uo5b75wcwzk.jpg",
            "isHeroImage": false
          },
          {
            "altText": null,
            "height": 2534,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec4yuj008w0uo57d1l2qk7.jpg",
            "isHeroImage": false
          },
          {
            "altText": null,
            "height": 2534,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec5elh008y0uo5a6wxbfge.jpg",
            "isHeroImage": false
          },
          {
            "altText": null,
            "height": 2527,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec5l3b00900uo528jt49h8.jpg",
            "isHeroImage": false
          },
          {
            "altText": null,
            "height": 2534,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec5wyf00920uo5elq7g20c.jpg",
            "isHeroImage": false
          },
          {
            "altText": null,
            "height": 2534,
            "width": 3801,
            "url": "https://cdn.impala.travel/properties/cknec88e3009d0uo5f13ycdp8.jpg",
            "isHeroImage": false
          }
        ],
        "address": {
          "line1": "115 Welfare Road",
          "line2": null,
          "city": cityOfHotel,
          "postalCode": "0",
          "region": null,
          "country": "SXM",
          "countryName": "Sint Maarten"
        },
        "location": {
          "longitude": -63.0942208,
          "latitude": 18.0351654
        },
        "amenities": [
          {
            "code": 5,
            "formatted": "Air conditioning"
          },
          {
            "code": 76,
            "formatted": "Restaurant"
          },
          {
            "code": 165,
            "formatted": "Lounges/bars"
          },
          {
            "code": 168,
            "formatted": "Onsite laundry"
          },
          {
            "code": 233,
            "formatted": "Tennis court"
          },
          {
            "code": 234,
            "formatted": "Water sports"
          },
          {
            "code": 342,
            "formatted": "Snack bar"
          },
          {
            "code": 1,
            "formatted": "24-hour front desk"
          },
          {
            "code": 84,
            "formatted": "Spa"
          },
          {
            "code": 198,
            "formatted": "Non-smoking rooms (generic)"
          },
          {
            "code": 345,
            "formatted": "Fitness Center"
          }
        ],
        "roomCount": 140,
        "checkIn": {
          "from": "16:00",
          "to": "00:00"
        },
        "checkOut": {
          "to": "10:00"
        },
        "termsAndConditions": "",
        "createdAt": "2021-04-12T09:01:45.745Z",
        "updatedAt": "2021-04-12T09:01:45.745Z",
        "externalUrls": [],
        "roomTypes": [
          {
            "roomTypeId": "bb1e2abe-e0ad-45c0-83a1-139b40a0ce3c",
            "name": "2 Bedroom Ocean View",
            "description": "Discover comfortable accommodations featuring a king size bed and a queen size sofa bed in the living room. Fall asleep each night to the tranquil sounds of the ocean’s tide and wake up each morning to breathtaking ocean views from your balcony or terrace. Bathroom amenities include a walk-in shower, complimentary amenities and hair dryer. Enjoy the convenience of our full kitchen equipped with a refrigerator, microwave and dishwasher. Additional in-room amenities include cable/satellite television, VCR/DVD player, telephone, air conditioning and easy beach access.",
            "roomPrice": 186,
            "rates": [],
            "amenities": [
              {
                "code": 77,
                "formatted": "Oven"
              },
              {
                "code": 126,
                "formatted": "Air conditioning individually controlled in room"
              },
              {
                "code": 18,
                "formatted": "Cable television"
              },
              {
                "code": 85,
                "formatted": "Private bathroom"
              },
              {
                "code": 123,
                "formatted": "Wireless internet connection"
              },
              {
                "code": 92,
                "formatted": "Safe"
              },
              {
                "code": 11,
                "formatted": "Bathroom amenities (free toiletries)"
              },
              {
                "code": 97,
                "formatted": "Shower only"
              },
              {
                "code": 167,
                "formatted": "Toaster"
              },
              {
                "code": 163,
                "formatted": "DVD player"
              },
              {
                "code": 157,
                "formatted": "Ceiling fan"
              },
              {
                "code": 19,
                "formatted": "Coffee/Tea maker"
              },
              {
                "code": 32,
                "formatted": "Dishwasher"
              },
              {
                "code": 50,
                "formatted": "Hairdryer"
              },
              {
                "code": 55,
                "formatted": "Iron (ironing facilities)"
              },
              {
                "code": 59,
                "formatted": "Kitchen"
              },
              {
                "code": 68,
                "formatted": "Microwave"
              }
            ],
            "images": [
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecef9900a30uo51wn0d0oy.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecyvqv00b60uo572756nph.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecy2nl00b40uo5glxy2itq.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecxh0c00b30uo53fnzbsb3.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecw0t600b00uo56m4u7qye.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecvlmu00az0uo511lu97ej.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecv6fx00ax0uo5b7wc92pj.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecdfqd009w0uo52ekobr61.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecuqp900aw0uo5aqxtcefd.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecueuz00au0uo5h88lfscs.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecstun00ar0uo57je06niw.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/ckneclf0u00aj0uo52ms5e4c7.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknechw4b00ag0uo54hxeffoe.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecgiwk00ae0uo5bxsofwpb.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecg6am00ad0uo5h3fl6xl9.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecfu2u00aa0uo5asi3gr7t.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecdqeu009z0uo50haq8hib.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknece3po00a00uo5geps9o7w.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/ckneceqm700a50uo575gv6z8e.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecf6sl00a60uo51qh253jb.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3763,
                "url": "https://cdn.impala.travel/properties/cknecficf00a90uo52yje9lk3.jpg"
              }
            ]
          },
          {
            "roomTypeId": "38a37699-e5a8-4aa4-a54a-8444eb5b7993",
            "name": "1 Bedroom Ocean View",
            "description": "Discover comfortable accommodations featuring a king size bed and a queen size sofa bed in the living room. Fall asleep each night to the tranquil sounds of the ocean’s tide and wake up each morning to breathtaking ocean views from your balcony or terrace. Bathroom amenities include a walk-in shower, complimentary amenities and hair dryer. Enjoy the convenience of our full kitchen equipped with a refrigerator, microwave and dishwasher. Additional in-room amenities include cable/satellite television, VCR/DVD player, telephone, air conditioning and easy beach access.",
            "roomPrice": 184,
            "rates": [],
            "amenities": [
              {
                "code": 59,
                "formatted": "Kitchen"
              },
              {
                "code": 68,
                "formatted": "Microwave"
              },
              {
                "code": 85,
                "formatted": "Private bathroom"
              },
              {
                "code": 77,
                "formatted": "Oven"
              },
              {
                "code": 32,
                "formatted": "Dishwasher"
              },
              {
                "code": 19,
                "formatted": "Coffee/Tea maker"
              },
              {
                "code": 18,
                "formatted": "Cable television"
              },
              {
                "code": 11,
                "formatted": "Bathroom amenities (free toiletries)"
              },
              {
                "code": 92,
                "formatted": "Safe"
              },
              {
                "code": 97,
                "formatted": "Shower only"
              },
              {
                "code": 123,
                "formatted": "Wireless internet connection"
              },
              {
                "code": 126,
                "formatted": "Air conditioning individually controlled in room"
              },
              {
                "code": 157,
                "formatted": "Ceiling fan"
              },
              {
                "code": 163,
                "formatted": "DVD player"
              },
              {
                "code": 167,
                "formatted": "Toaster"
              },
              {
                "code": 50,
                "formatted": "Hairdryer"
              },
              {
                "code": 55,
                "formatted": "Iron (ironing facilities)"
              }
            ],
            "images": [
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned0efs00bf0uo5gznv7vw4.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned5t3z00ca0uo5fpok75ec.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned6we200cc0uo5gi43164d.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned7gef00cd0uo5d9ia8049.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned3o0n00c60uo5af8f80r6.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned48aj00c80uo55fobaru1.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned5cfx00c90uo50rwn1549.jpg"
              },
              {
                "altText": null,
                "height": 2533,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckneczyrb00bc0uo56bftb7l2.jpg"
              },
              {
                "altText": null,
                "height": 2533,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned06ln00bd0uo5by7481hf.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned0mrl00bi0uo5ecud5dfh.jpg"
              },
              {
                "altText": null,
                "height": 2533,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned0z7k00bm0uo542b7hqmz.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned1g0f00bp0uo5bxms0zlm.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned1xec00bu0uo5eep51r2a.jpg"
              },
              {
                "altText": null,
                "height": 2534,
                "width": 3801,
                "url": "https://cdn.impala.travel/properties/ckned315f00c00uo54d6eeqa0.jpg"
              }
            ]
          }
        ]
      }

      const handleSubmit = () => {
            dispatch(addData(dataToAdd))
            setCityOfHotel('')
            setCurrencyOfHotel('')
            setNameOfHotel('')
            setPhoneNumberOfHotel('')
            setPriceOfHotel('')
            setStarOfHotel('')
            toast({
              title: 'Data added successfully',
              status: 'success',
              duration: 2000,
            })
      }


    return(
        <div>
            <Box>
            <Input w={['90%','90%','50%','30%']} placeholder='Name of Hotel/Resort' m='auto' mt='20px' type='text' value={nameOfHotel} onChange={(e)=>setNameOfHotel(e.target.value)} />
            <br />
            <Input w={['90%','90%','50%','30%']} m='auto' type='text' placeholder="City of Hotel to be listed" mt='20px' value={cityOfHotel} onChange={(e)=>setCityOfHotel(e.target.value)} />
            <br />
            <Input w={['90%','90%','50%','30%']} m='auto' placeholder="Currency to be accepted" mt='20px' type='text' value={currencyOfHotel} onChange={(e)=>setCurrencyOfHotel(e.target.value)} />
            <br />
            <Input w={['90%','90%','50%','30%']} m='auto' type='text' placeholder="Price to be shown to customer" mt='20px' value={priceOfHotel} onChange={(e)=>setPriceOfHotel(e.target.value)} />
            <br />
            <Input w={['90%','90%','50%','30%']} m='auto' type='text' placeholder="Stars" mt='20px' value={starOfHotel} onChange={(e)=>setStarOfHotel(e.target.value)} />
            <br />
            <Input w={['90%','90%','50%','30%']} m='auto' type='text' placeholder="Phone number" mt='20px' value={phoneNumberOfHotel} onChange={(e)=>setPhoneNumberOfHotel(e.target.value)} />
            <br />
            <Button w={['90%','90%','50%','30%']} m='auto' mt='20px'  onClick={handleSubmit}>List my property</Button>
            </Box>
            
        
        </div>
    )
}

export default AddProduct